import { Injector } from '@angular/core';
import { IFileDriver } from '../drivers/file-driver.interface';

export class Drive {
  unit: string;
  name: string;
  driver: IFileDriver;

  private mounted = false;

  constructor(private settingsFile: string, data?: { unit?: string, name?: string, driver?: IFileDriver }) {
    if (data) {
      Object.assign(this, data);
    }
  }

  get fullName() {
    return `${this.name} (${this.unit}:)${this.mounted ? '' : ' *Unmounted*'}`;
  }

  get isMounted() {
    return this.mounted;
  }

  async mount(unit: string, injector: Injector) {
    if (!this.mounted) {
      await this.driver.mount(unit, this.settingsFile, injector);
      this.mounted = true;
    }
  }
}
